import ErrorMessage from 'components/common/ErrorMessage';
import { AuthLayout } from 'layouts/AuthLayout';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { resetPassword } from 'slices/userSlice';
import { userSelector } from 'slices/userSlice';
import { setError } from 'slices/userSlice';
import { login } from 'slices/userSlice';


const Footer = memo(() => (
    <div className='center_wrapper'>
        <p className="para3">Don’t have Interpreter Account? <Link to="/register">Let’s Create One!</Link></p>
    </div>
))

function ResetPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error } = useSelector(userSelector)
    const {state} = useLocation();

    const [formValues, setFormValues] = useState({
        password: '',
        confirmPassword: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = useState("");

    const handleChange = useCallback((e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    }, [formValues])

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
    className:"successToast",
})
            navigate('/reset-password');
        }
        else {
             toast.error(message,
        {
          className:"errorToast",
        }
      );
        }
    };
    const resetAllErrors = () => {
        dispatch(setError({}))
    }
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        resetAllErrors()
        dispatch(resetPassword(formValues, submitCallback))
    }, [formValues]);

    
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };



    return (
        <AuthLayout
            heading="Set New Password"
            title=""
            footer={<Footer />}
        >
            <form className='auth_form' action='' onSubmit={handleSubmit}>
                <div className="form-group">
                    <div className="form-group">
                        <div className="row-input">
                            <img src="/images/lock.png" alt="" />
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password" id="password"
                                autoComplete="off"
                                onChange={handleChange}
                                placeholder="Enter a new password"
                                required
                            />
                            <img
                                src={showPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                alt=""
                                onClick={togglePasswordVisibility}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="row-input">
                            <img src="/images/lock.png" alt="" />
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="password_confirmation"
                                id="password_confirmation"
                                autoComplete="off"
                                placeholder="Enter Confirm password"
                                onChange={handleChange}
                                required
                            />
                            <img
                                src={showConfirmPassword ? "/images/eye-close.png" : "/images/eye.png"}
                                alt=""
                                onClick={toggleConfirmPasswordVisibility}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    {/* {confirmPasswordError && <div className='error-message'>{confirmPasswordError}</div>} */}
                    {
                        error?.errors?.password?.map((error) => (
                            <ErrorMessage text={error} />
                        ))
                    }
                </div>
                <button className="btn_auth">Reset Password</button>
            </form>
        </AuthLayout>
    )

}

export default ResetPassword;
